import { deliveryServerInstance } from '../axios/instances';
import { SELF_PICKUP as type } from './types';

/**
 * @param {string} order_ids
 * @param {string} driver_id
 * @param {number} delivery_type // 2
 * @param {number} delivery_result // 0
 * @param {document} pod_images[]
 */
export function customerPickupUpdate(formData) {
    return function (dispatch) {
        dispatch({ type: type.CUSTOMER_PICKUP_UPDATE })
        return deliveryServerInstance.post(`/delivery/batch`, formData)
            .then(({ data }) => {
                dispatch({
                    type: type.CUSTOMER_PICKUP_UPDATE_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: type.CUSTOMER_PICKUP_UPDATE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {formdata} signature
 */
export function handleSignature(signature) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_SIGNATURE })
        return (
            dispatch({
                type: type.HANDLE_SIGNATURE,
                payload: signature
            })
        )
    }
}

/**
 * @param {array} orders - array of order objects
 */
export function handleScannedTnos(orders) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_SCANNED_TNOS })
        return (
            dispatch({
                type: type.HANDLE_SCANNED_TNOS,
                payload: orders
            })
        )
    }
}

/**
 * @param {array} orders - array of order objects
 */
export function handleValidTnos(orders) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_VALID_TNOS })
        return (
            dispatch({
                type: type.HANDLE_VALID_TNOS,
                payload: orders
            })
        )
    }
}

/**
 * @param {string} tnos
 */
export function saveSearchTnos(tnos) {
    return function (dispatch) {
        dispatch({ type: type.SAVE_SEARCH_TNOS })
        return (
            dispatch({
                type: type.SAVE_SEARCH_TNOS,
                payload: tnos
            })
        )
    }
}